/** The path segment standing in for the id while an installation is not saved yet. */
export const NEW_CONNECTION_SEGMENT = 'new';

/** URL parameter naming the plugin a new installation is created for. */
export const CONNECTION_PLUGIN_PARAM = 'plugin';

/** URL parameter pinning a new bridged installation to one bridge. */
export const CONNECTION_BRIDGE_PARAM = 'bridge';

/** URL parameter naming the page the installation editor goes back to. */
export const CONNECTION_RETURN_TO_PARAM = 'returnTo';

/** URL parameter that tells the page returned to which installation was just created. */
export const CREATED_CONNECTION_PARAM = 'connection';

/** Former list parameter that opened one installation; now redirects to its page. */
export const LEGACY_EDIT_PARAM = 'edit';

/** Former list parameter that opened a new installation of a plugin; now redirects to the page. */
export const LEGACY_CREATE_PARAM = 'create';

/** URL parameter naming the entity a new installation must serve; narrows the bridges offered. */
export const CONNECTION_ENTITY_PARAM = 'entity';

/** URL parameter naming the help block the installation page opens once, then drops. */
export const CONNECTION_HELP_PARAM = 'help';

/** The help blocks of the installation form, by the value `?help=` names them with. */
export const ConnectionHelpTopic = {
  SHARED_ICO: 'shared-ico'
} as const;

export type ConnectionHelpTopic = (typeof ConnectionHelpTopic)[keyof typeof ConnectionHelpTopic];
